export class RespostaItem {
    public id: number;
    // descricao eh pra campos text ou input ou data
    public descricao: string;
    // valor selecionada na combo quando o tipoOpcao eh Resposta de outro questionario
    public opcaoValor: number;
    // opcoes eh pra campos selectmany
    public opcoes: number[];
    // caso o dado seja numerico
    public numero: number;
    // caso o dado seja um data
    public data: Date;
    // caso o dado seja um arquivo
    public arquivo: string;
    // caso o dado seja um arquivo
    public arquivoTipo: string;
    // id da RespostaItemArquivo
    public itemRespostaArquivo:number;
    // codigo pergunta
    public pergunta: number;
    // codigo resposta
    public resposta: number;
    // codigo da opcao
    public opcao: number;
    // campo necessario para mostrar na lista de resposta o enunciado da pergunta
    public coluna: string;
    // campo necessario para mostrar na lista de resposta o resultado em formato texto da opcao selecionada
	  public colunaDados: string;
}
